import { orderXClient } from '@/service/client'
import { DataPayload, TreeNewsHistoryRequest, TreeNewsPostList } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchTreeNewsHistory(payload: TreeNewsHistoryRequest = {}) {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { treeNewsHistory: payload },
      { headers: { 'X-Decode-Key': 'datapayload' } }
    )
    const postList = data.treeNewsPostList
    if (!postList) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch Tree News history',
      })
    }
    return postList as TreeNewsPostList
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
